// extracted by mini-css-extract-plugin
module.exports = {"launchDateDiv":"LaunchDateHeader_launchDateDiv__28qCL","launchDateHeaderDiv":"LaunchDateHeader_launchDateHeaderDiv__38Nbw","tokenCoinImg":"LaunchDateHeader_tokenCoinImg__3iEU-"};